import type { CustomProduct } from "@apptus/esales-api";

export const EXPLODED_PRODUCT_KEY = "exploded-product";

export default function isProductExploded(product: CustomProduct) {
  if (!product.custom) return false;
  const { variantFlags = [], productFlags = [] } = product.custom;
  const flags = [...variantFlags, ...productFlags].flatMap((flag) => flag.id);
  return flags.some((flag) => flag === EXPLODED_PRODUCT_KEY);
}
